import { Skeleton } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useCreateChartTheme } from '../../../../../theme';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Plugin personalizado para mostrar el total de las 3 categorías de demora por barra
const dataLabelsPlugin = {
  id: 'dataLabels',
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    ctx.font = '11px Arial';
    ctx.fillStyle = chart.options.plugins.dataLabelsPlugin?.fillStyle || '#000';
    ctx.textBaseline = 'middle';

    // Calcular totales por cada índice (cada barra/delegación)
    const totals = [];
    const numLabels = chart.data.labels.length;

    // Inicializar array de totales
    for (let i = 0; i < numLabels; i++) {
      totals[i] = 0;
    }

    // Sumar valores de todos los datasets para cada índice
    chart.data.datasets.forEach((dataset) => {
      dataset.data.forEach((value, index) => {
        totals[index] += value || 0;
      });
    });

    // Para barras horizontales apiladas, necesitamos encontrar el punto más a la derecha
    chart.data.labels.forEach((label, labelIndex) => {
      const total = totals[labelIndex];

      if (total > 0) {
        let maxX = 0;
        let barY = 0;

        // Encontrar el punto más a la derecha de todos los datasets para esta etiqueta
        chart.data.datasets.forEach((dataset, datasetIndex) => {
          const meta = chart.getDatasetMeta(datasetIndex);
          const bar = meta.data[labelIndex];

          if (bar && dataset.data[labelIndex] > 0) {
            // Para barras horizontales, x es la posición horizontal
            const barRight = bar.x;
            if (barRight > maxX) {
              maxX = barRight;
              barY = bar.y;
            }
          }
        });

        // Dibujar el total al final de la barra apilada completa
        if (maxX > 0) {
          ctx.fillText(total.toLocaleString(), maxX + 10, barY);
        }
      }
    });
  },
};

const OPTIONS = {
  responsive: true,
  indexAxis: 'y',
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'top',
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: true, // ❌ oculta las líneas verticales
        drawBorder: true,
      },
    },
    y: {
      stacked: true,
      grid: {
        display: false, // ❌ oculta las líneas horizontales
        drawBorder: false,
      },
      ticks: {
        beginAtZero: true,
      },
    },
  },
};

export const GraficoBar = ({ labels, datasets, options, ...props }) => {
  const { chartTheme } = useCreateChartTheme({
    ...OPTIONS,
    ...options,
  });

  return (
    <>
      {labels && datasets && labels.length > 0 && datasets.length > 0 ? (
        <Bar options={chartTheme} data={{ labels, datasets }} plugins={[dataLabelsPlugin]} />
      ) : (
        <Skeleton
          variant='rectangular'
          width={'100%'}
          height={'100%'}
          sx={{ borderRadius: '8px' }}
        />
      )}
    </>
  );
};
